export const SMALL = 'small';
export const MULTIPROPERTY = 'multiproperty';
export const MOBILE_MULTIPROPERTY = 'mobile-multiproperty';
export const SINGLE_PROPRETY = 'single-property';
export const REGULAR = 'regular';
export const REGULAR_BIG = 'regular-big';
export const HORIZONTAL = 'horizontal';
export const SMALL_MULTIPROPERTY = 'small-multiproperty';

export const WIDGET_ACTIONS = {
    EMAIL: 'email',
    EMAIL_FORM: 'emailForm',
    TEL: 'tel',
    MESSENGER: 'messenger',
    CLICK_2_CALL: 'click2call',
    SHOW_CONTACT_US_FORM: 'showContactUsForm',
    SHOW_CLICK_2_CALL_FORM: 'showClick2CallForm',
    SHOW_SHARE_HOTEL_FORM: 'showShareHotelForm',
};

export const dayStatus = {
    AVAILABLE: 'AVL',
    SOLD_OUT: 'SLD',
    MIN_STAY: 'MIN',
    NOT_AVAILABLE: 'NA',
    STOP_SALE: 'SS',
    CALL_US: 'CLOUT',
};

export const searchKeys = {
    NUMBER_OF_ROOMS: 'numberOfRooms',
    ADULTS: 'adults',
    CHILDREN: 'children',
};

export const CLICK_ACTIONS = {
    OPEN_PLUGIN: 'openplugin',
    OPEN_BIG_PLUGIN: 'openbigplugin',
    LINK: 'link',
    OPEN_EMAIL_FORM: 'OPEN_EMAIL_FORM',
    OPEN_CLICK_2_CALL: 'OPEN_CLICK_2_CALL',
    OPEN_CHAT: 'OPEN_CHAT',
};

export const sessionStorageKeys = {
    CLOSED_OFFER_POPUPS: 'closedOfferPopups',
};

export const dateFormatStr = 'EEE d.L';
export const dateFormatV2Str = 'EEE d.L.yy';
export const dateFormatMobileStr = 'd MMM';
export const noReCaptchaPublicKey = 'reCAPTCHA: No public key provided';
export const MAX_SEARCH_NIGHTS = 20;

// CSS
export const MAX_ZINDEX_VALUE = 2147483647;
